import { getAuthenticatedFetch } from "../../msal/authenticatedFetchService";

class LogsService {
    async getSignInLogs() {
        let url = `${process.env.REACT_APP_SELF_SERVICE_SHARED_API_URL}/Logs/signins`;
        let response = await getAuthenticatedFetch()(url);
        return await response.json();
    }

    async getActivityLogs() {
        let url = `${process.env.REACT_APP_SELF_SERVICE_SHARED_API_URL}/Logs/userlogs`;
        let response = await getAuthenticatedFetch()(url);
        return await response.json();
    }
}

export default new LogsService();
